import { render, staticRenderFns } from "./statisticCircle.vue?vue&type=template&id=0a3249d7&scoped=true"
import script from "./statisticCircle.vue?vue&type=script&lang=js"
export * from "./statisticCircle.vue?vue&type=script&lang=js"
import style0 from "./statisticCircle.vue?vue&type=style&index=0&id=0a3249d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3249d7",
  null
  
)

export default component.exports